/**
 * Fila Configuration Types
 *
 * Tipos e interfaces para configurações do sistema de fila digital
 */

// Fonte única em shared/: a definição estava duplicada aqui e lá, e shared/
// importava deste arquivo — dependência invertida entre app e código comum.
// Importado além de reexportado porque o próprio arquivo usa o tipo abaixo.
import type { OrderType } from '@services/api/orderTypes';
export type { OrderType };

export type WebSocketUpdateMode = 'replace' | 'update-status';

export interface VisibleColumns {
  fila: boolean;
  preparando: boolean;
  pronto: boolean;
}

export interface IntervalConfig {
  id: string;
  name: string;
  startTime: string;
  endTime: string;
  isActive: boolean;
  establishmentId?: string;
  orderCount?: number;
}

export interface FilaConfig {
  visibleColumns: VisibleColumns;
  orderType: OrderType;
  autoIntervalChange: boolean;
  selectedInterval?: string;
  selectedIntervalName?: string; // Nome do intervalo selecionado para exibição
  currentInterval?: IntervalConfig; // Intervalo atual completo (em modo automático ou manual)
  establishmentId?: string;
  websocketUpdateMode: WebSocketUpdateMode;
  orderNumberTextSize: number; // Tamanho do texto do número do pedido em rem
  queueTitleTextSize: number; // Tamanho do texto do título das filas em rem
}

export interface FilaConfigState extends FilaConfig {
  isLoading: boolean;
  error: string | null;
}

// Local Storage Keys
export const FILA_CONFIG_STORAGE_KEY = 'fila_digital_config';

// Default Configuration
export const DEFAULT_FILA_CONFIG: FilaConfig = {
  visibleColumns: {
    fila: true,
    preparando: true,
    pronto: true,
  },
  orderType: 'queue',
  autoIntervalChange: false,
  websocketUpdateMode: 'replace', // Default to replace mode for backward compatibility
  orderNumberTextSize: 3, // Tamanho padrão para número do pedido (equivalente a text-5xl)
  queueTitleTextSize: 2.25, // Tamanho padrão para título das filas (equivalente a text-4xl)
};

// Validation Schema
export interface FilaConfigValidation {
  isValid: boolean;
  errors: Record<string, string>;
}